import PdfLanguageProvider from "./pdf-language-provider";
import PdfPreview from "Components/pdf-preview";
import { Modal } from "react-bootstrap";

function PdfPreviewModal ({...props}: any) {
  const {
    downloadFlag,
    setDownloadFlag,
    printCanvas,
    setPrintCanvas,
    setGeneratePdfFlag,
    generatePdfFlag,
    setPdfFile,
    pdfFile,
    setLoader,
    loader,
    setOrderPdfDownload,
    orderPdfDownload,
    onHide,
    order,
    rebars,
    nets,
    piles,
    headers,
    setPdfType,
    pdfType,
    bidFees,
    pdfLanguage,
    feeType,
    pricingSnapshot,
  } = props;
  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-document-w"
      >
        <PdfLanguageProvider key={pdfLanguage || "ui"} language={pdfLanguage}>
        <PdfPreview
          downloadFlag={downloadFlag}
          setDownloadFlag={() => setDownloadFlag(false)}
          printCanvas={printCanvas}
          setPrintCanvas={() => setPrintCanvas(false)}
          setGeneratePdfFlag={() => setGeneratePdfFlag(false)}
          generatePdfFlag={generatePdfFlag}
          setPdfFile={setPdfFile}
          pdfFile={pdfFile}
          headers={headers}
          setLoader={setLoader}
          loader={loader}
          setOrderPdfDownload={() => setOrderPdfDownload(false)}
          orderPdfDownload={orderPdfDownload}
          onHide={onHide}
          order={order}
          rebars={rebars}
          nets={nets}
          piles={piles}
          priceShow={false}
          pricingSnapshot={pricingSnapshot}
          setPdfType={setPdfType}
          pdfType={pdfType}
          bidFees={bidFees}
          pdfLanguage={pdfLanguage}
          feeType={feeType}
        />
        </PdfLanguageProvider>
      </Modal>
    </>
  );
}

export default PdfPreviewModal;
